module.exports = __webpack_public_path__ + "img/7fc9e42d9882e25a46b5f998d0a636cb.7fc9e42d.png";